<template>
  <span data-testid="workflow-review-status-reviewers">
    <span v-if="hasAnyUpToDateReview">{{
      I18n.t('reconciliation_review.reviewed_by')
    }}</span>
    <span v-else>{{
      I18n.t('reconciliation_review.previously_reviewed_by')
    }}</span>
    <span v-for="(review, idx) in reviewsToShow" :key="review.name">
      <span v-tooltip.timestamp="review.time" class="sf-font-bold">{{
        review.name
      }}</span
      ><span v-if="idx < reviewsToShow.length - 1">, </span>
    </span>
  </span>
</template>

<script>
const WorkflowReviewStatusReviewedBy = {
  props: ['hasAnyUpToDateReview', 'reviewsToShow'],
}

export default WorkflowReviewStatusReviewedBy
</script>
